import { useRouter } from "next/router"
import { Container, Stack, Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import {
    OEFR_BUSINESS_UNIT_ID,
    OEFR_TEMPLATE_ID,
    Trustpilot,
    TrustpilotTags,
} from "@/features/trustpilot"

export function SubscriptionTrustpilot() {
    const t = useTranslations("SubscriptionTrustpilot")
    const { locale } = useRouter()

    return (
        <Container
            theme="base900"
            paddingY="lg"
        >
            <Container
                fullWidth
                maxWidthPreset="lg"
                marginX="auto"
                padding="sm"
            >
                <Stack
                    alignItems="center"
                    flexDirection="column"
                    gap="lg"
                >
                    <Typography
                        textStyle="h3"
                        component="p"
                    >
                        {t("title")}
                    </Typography>
                    <Container fullWidth>
                        <Trustpilot
                            templateId={OEFR_TEMPLATE_ID}
                            businessUnitId={OEFR_BUSINESS_UNIT_ID}
                            tags={TrustpilotTags.SelectedReview}
                            reviewLanguages={locale}
                            disableInteraction
                        />
                    </Container>
                </Stack>
            </Container>
        </Container>
    )
}

SubscriptionTrustpilot.messages = ["SubscriptionTrustpilot"] as const
